<div>

    <div class="p-b-20">
        <span class="font-h6">Datos de Perfil</span>
    </div>

    <form class="form-horizontal form-material" [formGroup]="registerForm" (ngSubmit)="onSubmit()" #formDir="ngForm">
        
            <!-- Name -->
            <div class="name-inputs">    
                <!-- firstName -->
                <div class="form-group col-lg-6 col-md-6 col-sm-4" [ngClass]="{'has-danger': invalidFirstName}">
                    <label class="font-l1 pl-1">Nombre</label>
                    <input class="form-control" formControlName="firstName" placeholder="Nombre">
                    <small class="form-control-feedback" *ngIf="invalidFirstName">
                        El nombre es requerido.
                    </small>
                </div>
    
                <!-- lastName -->
                <div class="form-group col-lg-6 col-md-6 col-sm-4" [ngClass]="{'has-danger': invalidLastName}">
                    <label class="font-l1 pl-1">Apellido</label>
                    <input class="form-control" formControlName="lastName" placeholder="Apellido">
                    <small class="form-control-feedback" *ngIf="invalidLastName">
                        El apellido es requerido.
                    </small>
                </div>
            </div>  

            <label class="font-l1">Fecha de nacimiento <small>(para enviarte un regalo en tu cumpleaños)</small></label>
            <div class="born-date"> 
                <!-- year  -->
                <div class="form-group col-sm-4" [ngClass]="{'has-danger': invalidBirthYear}">
                    <!-- <label class="font-l1">Año</label> -->
                    <div class="select">
                        <select class="form-control" formControlName="birthYear" placeholder="Año de nacimiento" (change)="changeBirthYear()">
                            <option *ngFor="let item of allYears" [value]="item">{{item}}</option>
                        </select>
                    </div>
                    <small class="form-control-feedback" *ngIf="invalidBirthYear">
                        El año es requerido.
                    </small>
                </div>

                <!-- month  -->
                <div class="form-group col-sm-4" [ngClass]="{'has-danger': invalidBirthMonth}">
                    <!-- <label class="font-l1">Mes</label> -->
                    <div class="select">
                        <select class="form-control" formControlName="birthMonth" placeholder="Mes de nacimiento" (change)="changeBirthMonth()">
                            <option *ngFor="let item of allMonths; let i = index" [value]="i+1">{{item}}</option>
                            <option value="0" disabled>Mes</option>
                        </select>
                    </div>
                    <small class="form-control-feedback" *ngIf="invalidBirthMonth">
                        El mes es requerido.
                    </small>
                </div>

                <!-- days  -->
                <div class="form-group col-sm-4" [ngClass]="{'has-danger': invalidBirthDay}">
                    <!-- <label class="font-l1">Día</label> -->
                    <div class="select">
                        <select class="form-control" formControlName="birthDay" placeholder="Día de nacimiento">
                            <option *ngFor="let item of dayList;" [value]="item + 1">{{item + 1}}</option>
                            <option value="0" disabled>Día</option>
                        </select>
                    </div>
                    <small class="form-control-feedback" *ngIf="invalidBirthDay">
                        El día es requerido.
                    </small>
                </div>
            </div> 
            
            <div class="row">
                <!-- CR -->
                <ng-container *ngIf="user.country == 1">
                    <!-- idCard type -->
                    <div class="form-group col-lg-12 col-md-12 col-sm-12" [ngClass]="{'has-danger': invalidIdCardType}">
                        <label class="font-l1">Tipo de identificación</label>
                        <div class="select">
                            <select class="form-control" formControlName="idCardType" placeholder="Tipo de identificación" (change)="validIdCard()">
                                <option value="0">Seleccioná la identificación</option>
                                <option value="1">Cédula Nacional</option>
                                <option value="2">Residente (DIMEX)</option>
                                <option value="3">Extranjero</option>
                            </select>
                        </div>
                        <small class="form-control-feedback" *ngIf="invalidIdCardType">
                            El tipo de identificación es requerido.
                        </small>
                    </div>

                    <!-- idCard -->
                    <div class="form-group col-lg-12 col-md-12 col-sm-12" [ngClass]="{'has-danger': invalidIdCard}">
                        <label class="font-l1">Identificación</label>
                        <input class="form-control" [ngClass]="{'input-upper': registerForm.controls.idCardType.value == 3}" formControlName="idCard" placeholder="Identificación" (click)="validIdCard()" [type]="dynamicType" [mask]="dynamicMask">
                        <div class="form-control-feedback" *ngIf="invalidIdCard">
                            <small *ngIf="(idCard.errors?.minlength || idCard.errors?.maxlength)">
                                La identificación debe tener entre 6 y 15 dígitos.
                            </small>
                            <small *ngIf="idCard.errors?.required">
                                La identificación es requerida.
                            </small>
                        </div>
                    </div>
                </ng-container>
                <!-- PA -->
                <ng-container *ngIf="user.country == 2 && false">
                    <div class="form-group col-lg-12 col-md-12 col-sm-12" [ngClass]="{'has-danger': invalidIdCardType}">
                        <label class="font-l1">Tipo de identificación (Panamá)</label>
                        <div class="select">
                            <select class="form-control" formControlName="idCardType" placeholder="Tipo de identificación" (change)="validIdCardPanama()">
                                <option value="0">Seleccioná la identificación</option>
                                <option value="1">Cédula</option>
                                <option value="2">Pasaporte</option>
                                <option value="3">Carné de Residente Permanente</option>
                            </select>
                        </div>
                        <small class="form-control-feedback" *ngIf="invalidIdCardType">
                            El tipo de identificación es requerido.
                        </small>
                    </div>
                    
                    <div class="form-group col-lg-12 col-md-12 col-sm-12" [ngClass]="{'has-danger': invalidIdCard}">
                        <label class="font-l1">Identificación (Panamá)</label>
                        <input class="form-control" [ngClass]="{'input-upper': registerForm.controls.idCardType.value == 3}" formControlName="idCard" placeholder="Identificación" (click)="validIdCardPanama()" [type]="dynamicType" [mask]="dynamicMask">
                        <div class="form-control-feedback" *ngIf="invalidIdCard">
                            <small *ngIf="(idCard.errors?.minlength || idCard.errors?.maxlength)">
                                El pasaporte debe tener entre 6 y 15 caracteres.
                            </small>
                            <small *ngIf="idCard.errors?.required">
                                La identificación es requerida.
                            </small>
                        </div>
                    </div>
                </ng-container>

                <!-- iGenderType -->
                <div class="form-group col-lg-12 col-md-12 col-sm-12 text-left" [ngClass]="{'has-danger': invalidGenderType}">
                    <label class="font-l1">Género</label>
                    <div class="select">
                        <select class="form-control" formControlName="genderType" placeholder="Género">
                            <option value="0">Seleccioná un género</option>
                            <option value="1">Masculino</option>
                            <option value="2">Femenino</option>
                            <option value="3">No aplica</option>
                        </select>
                    </div>
                    <small class="form-control-feedback" *ngIf="invalidGenderType">
                        El género es requerido.
                    </small>
                </div>

                <!-- Phone -->
                <div *ngIf="!validPhone" class="form-group col-lg-12 col-md-12 col-sm-12 text-left" [ngClass]="{'has-danger': invalidPhone}">
                    <label class="font-l1">Teléfono</label>
                    <input class="form-control" type="tel" formControlName="phone" mask="0000-0000" placeholder="Teléfono. Ej: 88888888">
                    <div class="form-control-feedback" *ngIf="invalidPhone">
                        <small *ngIf="phone.errors?.minlength">
                            El teléfono debe tener al menos 8 dígitos
                        </small>
                        <small *ngIf="phone.errors?.required">
                            El teléfono es requerido
                        </small>
                    </div>
                </div>
            </div>
            
            <!-- Geo Data -->
            <div class="row">
                <div *ngFor="let field of geoDataStructure" class="col-12 form-group">
                    <label [for]="field.key" class="font-l1">{{ field.name | titlecase }}:</label>
                    <div class="select">
                        <select class="form-control" [id]="field.key" [formControlName]="field.key" (change)="onSelect(field.key, $event.target.value)">
                            <option *ngFor="let option of filteredData[field.key]" [value]="option.id">
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                    <!-- Mensajes de error -->
                    <div *ngIf="registerForm.get(field.key)?.invalid && registerForm.get(field.key)?.touched" class="text-danger">
                        <small *ngIf="registerForm.get(field.key)?.hasError('required')">
                            El campo de {{ field.name | lowercase }} es requerido.
                        </small>
                    </div> 
                </div>
            </div> 

        <div class="form-group m-t-24 text-center">
            <button class="btn btn-primary w-100" type="submit" [disabled]="registerForm.invalid">Continuar</button>
        </div>

    </form>
</div>
